<template>
  <div>
    <div id="banner">
      <div class="slider-pro sp-horizontal" id="example1" style="width: 100%; max-width: 5200px">
        <div class="sp-slides">
          <!--
          <div class="sp-slide">
            <a href="javascript:void(1)"><img
                class="sp-image"
                src="~@/assets/15002842221.jpg"
                alt=""
                title="" /></a>
          </div>
          -->
          <div class="sp-slide">
            <a href="javascript:void(1)"><img
                class="sp-image"
                src="~@/assets/15011452161.png"
                alt=""
                title=""/></a>
          </div>
        </div>
      </div>
    </div>
    <div id="wrap_c">
      <div class="breadCrumb">
        <a href="/" tabindex="101" class="breadCrumb_no" title="首頁">首頁</a>
        <router-link :to="{name:'公司簡介'}"><span>關於白金</span></router-link>
        <router-link :to="{name:'企業社會責任'}"><span>企業社會責任</span></router-link>
      </div>

      <h2 class="titleA">企業社會責任</h2>
      <div id="page_left">
        <div id="menu_out">
          <div id="menu_c">
            <ul class="m_top"></ul>
            <li>
              <router-link :to="{name:'公司簡介'}" class="menu_on0">關於白金</router-link>
              <span
                style="cursor: hand"
                class="arrow_class_close"
                onclick="allshow_show_menu2(this,'2279','http://www.ptotinc.com/','0','','2280')">
                <img
                  src="~@/assets/folder_close.png"
                  id="img_son_menu_2279"
                  class="class_sonimg_0"/>
              </span>
            </li>
            <div id="son_menu_2279" class="class_sondiv_0" style="display: ">
              <ol>
                <router-link :to="{name:'公司簡介'}" class="menu_on0">公司簡介</router-link>
              </ol>

              <ol>
                <router-link :to="{name:'經營理念'}" class="menu_on0">經營理念</router-link>
              </ol>

              <ol>
                <router-link :to="{name:'核心競爭力'}" class="menu_on0">核心競爭力</router-link>
              </ol>

              <ol>
                <router-link :to="{name:'企業沿革'}" class="menu_on0">企業沿革</router-link>
              </ol>

              <ol>
                <router-link :to="{name:'企業社會責任'}" class="menu_on2">企業社會責任</router-link>
              </ol>

              <ol>
                <router-link :to="{name:'產業新聞'}" class="menu_on0">產業新聞</router-link>
              </ol>
            </div>
          </div>
        </div>
      </div>

      <div id="page_right_no">
        <!--###右側欄區塊###-->
      </div>

      <div id="page_main_2">
        <!--###內頁中間內容區塊###-->
        <div class="cC">
          <form
            method="POST"
            action="portal_c2_cnt.php?owner_num=c2_38424&amp;button_num=c2&amp;folder_id=2280&amp;search_type=1"
          >
            <div class="searchbar">
              <ul>
                <li>
                  尋找：

                  <select tabindex="62" name="search_field">
                    <option value="all_field">全部</option>
                    <option value="text_field_0">標題</option>
                  </select>
                  <input
                    tabindex="63"
                    name="search_word"
                    type="text"
                    class="input"
                    value=""
                  />
                  <input
                    tabindex="64"
                    name="search_b1"
                    type="submit"
                    class="btn"
                    value="查詢"
                  />
                  <!--<input name="Submit3" type="button" class="btn2" value="進階查詢" onclick="location.href='http://www.ptotinc.com/member/ptotinc/portal_c2_cnt.php?owner_num=c2_38424&button_num=c2&folder_id=2280&search_type=2';"/>-->
                </li>
              </ul>
            </div>
          </form>

<div class="cate_info">     <span style="font-size: 15px;"><strong><span style="font-size: 18px;">企業社會責任政策</span></strong><br>
&nbsp;<br>
白金科技認為企業的經營應秉持社會責任的理念，從人權、環保、道德、公益以及員工健康與安全的關注，以至於企業社會責任的擴展，皆須符合利益關係者(Stakeholder)的期待。<br>
&nbsp;<br>
落實企業社會責任不僅是成為國際大廠應承擔的義務，亦同時可為公司本身與利益關係者帶來合作的契機，並創造希望。<br>
&nbsp;</span>
<ol>
	<li><span style="font-size: 15px;">遵守社會責任相關規範，廉潔經營。</span></li>
	<li><span style="font-size: 15px;">遵守國際環保法規，節能減碳。</span></li>
	<li><span style="font-size: 15px;">創造優質工作環境，保障員工福利與各利益關係者之權益。</span></li>
	<li><span style="font-size: 15px;">尊重並保護客戶智慧財產，遵守各項保密協定。</span></li>
	<li><span style="font-size: 15px;">鼓勵利益關係者共同善盡社會責任。</span></li>
</ol>
<span style="font-size: 15px; "> &nbsp;<br>
♦ 品質政策<br>
追求卓越、不斷創新、顧客滿意<br>
&nbsp;<br>
♦ 環境政策<br>
管理有害物質、建立無害環境<br>
符合國際規範、不斷持續改善<br>
&nbsp;<br>
♦ 安全衛生政策<br>
遵守法規、全員參與、<br>
預防危害、風險管理、<br>
持續改善</span><br>
<br>
<font size="3">♦ 禁用衝突礦產準則</font><font color="#3e3121"> </font>

<ol>
	<li><font size="3">不支持、不使用來自武裝衝突、非法採礦與低劣工作環境中採礦而來的金屬，即所謂衝突礦產」。 </font></li>
	<li><font size="3">要求供應商調查材料中是否含有金(Au)、鉭(Ta)、錫(Sn)、鎢(W)、鈷(Co)等金屬，並確認這些金屬的礦源。</font></li>
	<li><font size="3">供應商必須履行企業社會責任，要求供應鏈進行商業上合理的盡責調查，以保證提供白金的產品中未使用上述五種衝突金屬。</font></li>
</ol>
<br>
<br>
<span style="font-size: 15px;">參考檔案：</span><a target="_blank" href="./static/企業社會責任管理手冊.pdf">企業社會責任管理手冊</a><br>
&nbsp; </div>

          <ul id="c_list"></ul>

          <br /><br />
          <p style="text-align: center"></p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

export default {
  name: 'social-responsibility',
  // mixins: [sliderPro],
  data () {
    return {
      msg: 'Social Responsibility'
    }
  },
  created: function () {
    console.log('created')
  },
  mounted: function () {
    console.log('moundted')
    this.init()
    // sliderPro.m1()
    // sliderProAddTitle('default', '%%%%%%%%%@@@%%%%%%%%%@@@', '%%%%%%%%%@@@%%%%%%%%%@@@')
    // sliderPro.initialSliderPro()
    // sliderPro.m1('default', '%%%%%%%%%@@@%%%%%%%%%@@@', '%%%%%%%%%@@@%%%%%%%%%@@@')
  },
  methods: {
    init: function () {
      $('#rwd_nav').pageslide({
          modal: true
      });
      $('.sp-selected .sp-font span').addClass('animated fadeInLeft');
      $('.sp-selected .sp-font2').addClass('animated fadeInRight');
      $('#example1').sliderPro({
          keyboardOnlyOnFocus: true,
          set_swipe: '1',
          width: '5120',
          height: '1280',
          autoplay: true,
          waitForLayers: true,
          autoScaleLayers: false,
          fade: true,
          autoplayDelay: 5000,
          arrows: false,
          buttons: false,
          breakpoints: {
            1024: {
              forceSize: '',
              width: '1024',
              height: '256'
            }
          }
      });
      sliderPro_add_title('default', '%%%%%%%%%@@@%%%%%%%%%@@@', '%%%%%%%%%@@@%%%%%%%%%@@@');
      initVideo();
    }
  }
}
</script>
<style src='@/assets/css/15347449502.css'>
</style>


// WEBPACK FOOTER //
// src/components/about/SocialResponsibility.vue